import API_URLS from '@Constants/apiUrls.constants';
import { UsersListRequestAndResponse } from '@Models/users.models';

import { baseApi } from './baseApi.service';

export const usersApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getUsersList: builder.query<
      UsersListRequestAndResponse,
      UsersListRequestAndResponse
    >({
      query: ({ pagination, sort, searchTerm }) => ({
        url: API_URLS.USERS.GET_USERS,
        method: 'POST',
        body: {
          pagination,
          sort,
          searchTerm,
        },
      }),
    }),
  }),
  overrideExisting: false,
});

export const { useGetUsersListQuery } = usersApi;
